var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stf{fill:white;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stf",
    d: "M256,6C117.9,6,6,117.9,6,256s111.9,250,250,250s250-111.9,250-250S394.1,6,256,6z M256,492.5 C125.4,492.5,19.5,386.6,19.5,256S125.4,19.5,256,19.5S492.5,125.4,492.5,256S386.6,492.5,256,492.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stf",
    d: "M216.1,280.9l-79.4,79.3l0-46.2c0-6-4.8-10.8-10.8-10.8S115,308,115,314v72.3c0,6,4.8,10.8,10.8,10.8h72.3 c6,0,10.8-4.9,10.8-10.8s-4.8-10.8-10.8-10.8H152l79.4-79.3c4.2-4.2,4.2-11.1,0-15.3C227.2,276.7,220.3,276.7,216.1,280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stf",
    d: "M386.2,114.8h-72.3c-6,0-10.8,4.9-10.8,10.8c0,6,4.8,10.8,10.8,10.8H360l-77.2,77.1c-4.2,4.2-4.2,11.1,0,15.3 c2.1,2.1,4.9,3.2,7.7,3.2c2.8,0,5.5-1.1,7.7-3.2l77.2-77.1V198c0,6,4.8,10.8,10.8,10.8S397,204,397,198v-72.3 C397,119.6,392.1,114.8,386.2,114.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullScreen);
export default __webpack_public_path__ + "static/media/icon-full-screen.8c661350cc0a677b39a6531de8f2a2dc.svg";
export { ForwardRef as ReactComponent };